<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors'"
            >Investors</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Create
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <investor-form
        formType="create"
        @saveInvestor="createInvestor"
      ></investor-form>
    </div>
  </div>
</template>
<script>
import InvestorForm from "./forms/investorForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
    };
  },
  components: {
    InvestorForm,
  },
  methods: {
    formValidation(investor) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (!investor.first_name || investor.first_name.length < 2) {
        missingFieldsString +=
          "Investor first name is less than 2 characters, ";
        result.isValid = false;
      }
      if (!investor.first_name || investor.last_name.length < 2) {
        missingFieldsString += "Investor last name is less than 2 characters, ";
        result.isValid = false;
      }
      if (!investor.home_address) {
        missingFieldsString += "Investor home address field is empty, ";
        result.isValid = false;
      }
      if (!investor.mobile_number) {
        missingFieldsString += "Investor mobile number field is empty, ";
        result.isValid = false;
      }
      if (!investor.date_of_birth) {
        missingFieldsString += "Investor date birth is not selected, ";
        result.isValid = false;
      }
      if (!investor.date_of_birth) {
        missingFieldsString += "Investor date birth is not selected, ";
        result.isValid = false;
      }
      let genderList = [0, 1, null];
      if (!genderList.includes(investor.gender)) {
        missingFieldsString += "Project gender should be selected, ";
        result.isValid = false;
      }
      let maritalStatusList = ["single", "married", "divorced", "widowed"];
      if (!maritalStatusList.includes(investor.marital_status)) {
        missingFieldsString += "Project marital status should be selected, ";
        result.isValid = false;
      }
      if (!investor.nationality_id) {
        missingFieldsString += "Investor nationality is not selected, ";
        result.isValid = false;
      }
      if (!investor.country_of_residence_id) {
        missingFieldsString +=
          "Investor country of residence is not selected, ";
        result.isValid = false;
      }
      if (!investor.pasport_id) {
        missingFieldsString += "Investor passport id field is empty, ";
        result.isValid = false;
      }
      if (!investor.emergency_contact_name) {
        missingFieldsString +=
          "Investor emergency contact name field is empty, ";
        result.isValid = false;
      }
      if (!investor.emergency_contact_number) {
        missingFieldsString +=
          "Investor emergency contact number field is empty, ";
        result.isValid = false;
      }
            if (!investor.user.email) {
        missingFieldsString +=
          "Investor email address field is empty, ";
        result.isValid = false;
      }
      if (investor.contract) {
        let contractValidation = this.contractFormValidation(investor.contract);
        if (!contractValidation.isValid) {
          missingFieldsString += contractValidation.message;
          result.isValid = false;
        }
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    contractFormValidation(contract) {
      const contractResult = { isValid: true, message: "" };
      let missingFieldsString = "";
      if (!contract.start_date) {
        missingFieldsString += "Contract start date is not selected, ";
        contractResult.isValid = false;
      }
      if (!contract.maturity_date) {
        missingFieldsString += "Contract maturity date is not selected, ";
        contractResult.isValid = false;
      }
      if (!contract.plan_id) {
        missingFieldsString += "Plan is not selected, ";
        contractResult.isValid = false;
      }
      if (!contract.invested_principal) {
        missingFieldsString += "Principal field is empty, ";
        contractResult.isValid = false;
      }
      let statusList = ["active", "inactive", "notstarted", "closed"];

      if (!statusList.includes(contract.status)) {
        missingFieldsString += "Contract status should be selected, ";
        contractResult.isValid = false;
      }
      let paymentTypes = ["cash", "banktransfer", "cheque", "blockchain"];

      if (!paymentTypes.includes(contract.payment_type)) {
        missingFieldsString += "Contract payment should be selected, ";
        contractResult.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        contractResult.message += missingFieldsString;
      }
      return contractResult;
    },
    createInvestor(investor) {
      const { isValid, message } = this.formValidation(investor);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("createInvestor", investor);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      createdInvestor: (state) =>
        state.investorStore.investorCreate.createdInvestor,
      createInvestorStatus: (state) =>
        state.investorStore.investorCreate.createInvestorStatus,
      updateInvestorStatus: (state) =>
        state.investorStore.investorUpdate.updateInvestorStatus,
      deleteInvestorStatus: (state) =>
        state.investorStore.investorDelete.deleteInvestorStatus,
    }),
  },
  watch: {
    createInvestorStatus() {
      if (this.createInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/investors");
        });
      } else if (this.createInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/createInvestor.vue